(function () {
  function show(el) {
    if (!el) return;
    el.removeAttribute('hidden');
    el.style.removeProperty('display');
  }

  function hide(el) {
    if (!el) return;
    el.setAttribute('hidden', 'hidden');
    el.style.setProperty('display', 'none', 'important');
  }

  async function fetchAllowsOnlineSale(root) {
    const id = root.dataset.productId;
    const base = (root.dataset.faceSaleEndpoint || '').trim();
    if (!id || !base) return true;
    const url = `${base}${id}`;
    const res = await fetch(url, { method: 'GET' });
    if (!res.ok) throw new Error('Face sale check failed');
    const payload = await res.json();
    return !(payload && payload.is_face_to_face_sale === true);
  }

  function updateDispatchVisibility(productId, allowed) {
    const normalizedProductId = String(productId || '').trim();
    document.querySelectorAll('[data-face-sale-hide-dispatch]').forEach((el) => {
      const elProductId = String(el.dataset.productId || '').trim();
      if (normalizedProductId && elProductId && elProductId !== normalizedProductId) return;
      if (allowed) {
        show(el);
      } else {
        hide(el);
      }
    });
  }

  function mount(root) {
    if (root.dataset.faceSaleGateStarted === '1') return;
    root.dataset.faceSaleGateStarted = '1';

    const tpl = root.querySelector('template[data-face-sale-buy-template]');
    const slot = root.querySelector('[data-face-sale-buy-slot]');
    const pending = root.querySelector('[data-face-sale-pending]');
    const blocked = root.querySelector('[data-face-sale-blocked]');
    const blockedMsg = root.dataset.faceSaleBlockMessage || '';
    const productId = root.dataset.productId;

    hide(blocked);
    show(pending);

    fetchAllowsOnlineSale(root)
      .then((allowed) => {
        updateDispatchVisibility(productId, allowed);
        hide(pending);
        if (!allowed) {
          if (blocked) {
            blocked.textContent = blockedMsg;
            show(blocked);
          }
          return;
        }
        if (!tpl || !slot) return;
        if (slot.dataset.faceSaleMounted === '1') return;
        slot.dataset.faceSaleMounted = '1';
        slot.appendChild(tpl.content.cloneNode(true));
      })
      .catch(() => {
        updateDispatchVisibility(productId, false);
        hide(pending);
        if (blocked) {
          blocked.textContent = 'No fue posible validar la compra online de este producto.';
          show(blocked);
        }
      });
  }

  function init() {
    document.querySelectorAll('[data-face-sale-buy-gate]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
